type ShellKind = 'member' | 'teaching' | 'employer' | 'admin';

const copy: Record<
    ShellKind,
    { label: string; title: string; note: string; navigation: string[] }
> = {
    member: {
        label: 'Member environment',
        title: 'Your community, ready for what comes next.',
        note: 'Scaffold only — member engines and identity begin in later authorised phases.',
        navigation: ['Home', 'Learning', 'Community'],
    },
    teaching: {
        label: 'Teaching environment',
        title: 'A focused place to guide learning.',
        note: 'Scaffold only — teaching workflows, cohorts, and assessment are not implemented.',
        navigation: ['Teaching home', 'Learning spaces', 'Support'],
    },
    employer: {
        label: 'Employer workspace',
        title: 'Build opportunity with clear evidence.',
        note: 'Scaffold only — employer verification, opportunities, and applications are deferred.',
        navigation: ['Organisation', 'Opportunities', 'Talent'],
    },
    admin: {
        label: 'Administration workspace',
        title: 'Operational clarity, without product shortcuts.',
        note: 'Scaffold only — no administration functions, permissions, or member data exist.',
        navigation: ['Overview', 'Operations', 'Assurance'],
    },
};

export function Shell({ kind }: { kind: ShellKind }) {
    const content = copy[kind];

    return (
        <div className={`shell shell--${kind}`} data-shell={kind}>
            <a className="skip-link" href="#main">
                Skip to main content
            </a>
            <header className="shell-bar">
                <div className="shell-frame shell-bar__inner">
                    <a className="wordmark" href="/" aria-label="SkillUp Africa home">
                        SkillUp <span>Africa</span>
                    </a>
                    <span className="status-pill">Scaffold preview</span>
                </div>
            </header>
            <div className="shell-grid">
                <nav className="shell-nav" aria-label={`${content.label} scaffold navigation`}>
                    <span className="eyebrow">{content.label}</span>
                    <ul>
                        {content.navigation.map((item) => (
                            <li key={item}>
                                <a href="#main">{item}</a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <main className="shell-main" id="main">
                    <span className="eyebrow">Phase 1 foundation</span>
                    <h1>{content.title}</h1>
                    <p className="shell-note">{content.note}</p>
                </main>
            </div>
        </div>
    );
}
